"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = usePonyfillContext;

var _react = require("react");

var _PonyfillContext = _interopRequireDefault(require("./PonyfillContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function usePonyfillContext() {
  var context = (0, _react.useContext)(_PonyfillContext.default);

  if (!context) {
    throw new Error('botframework-webchat: This hook can only be used under <PonyfillContext>.');
  }

  return context;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJ1c2VQb255ZmlsbENvbnRleHQiLCJjb250ZXh0IiwidXNlQ29udGV4dCIsIlBvbnlmaWxsQ29udGV4dCIsIkVycm9yIl0sInNvdXJjZVJvb3QiOiJjb21wb25lbnQ6Ly8vIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvcHJvdmlkZXJzL1BvbnlmaWxsL3ByaXZhdGUvdXNlQ29udGV4dC50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyB1c2VDb250ZXh0IH0gZnJvbSAncmVhY3QnO1xuXG5pbXBvcnQgUG9ueWZpbGxDb250ZXh0IGZyb20gJy4vUG9ueWZpbGxDb250ZXh0JztcblxuaW1wb3J0IHR5cGUgeyBDb250ZXh0IH0gZnJvbSAncmVhY3QnO1xuXG50eXBlIENvbnRleHRPZjxUPiA9IFQgZXh0ZW5kcyBDb250ZXh0PGluZmVyIEM+ID8gQyA6IG5ldmVyO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiB1c2VQb255ZmlsbENvbnRleHQoKTogRXhjbHVkZTxDb250ZXh0T2Y8dHlwZW9mIFBvbnlmaWxsQ29udGV4dD4sIHVuZGVmaW5lZD4ge1xuICBjb25zdCBjb250ZXh0ID0gdXNlQ29udGV4dChQb255ZmlsbENvbnRleHQpO1xuXG4gIGlmICghY29udGV4dCkge1xuICAgIHRocm93IG5ldyBFcnJvcignYm90ZnJhbWV3b3JrLXdlYmNoYXQ6IFRoaXMgaG9vayBjYW4gb25seSBiZSB1c2VkIHVuZGVyIDxQb255ZmlsbENvbnRleHQ+LicpO1xuICB9XG5cbiAgcmV0dXJuIGNvbnRleHQ7XG59XG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQTs7QUFFQTs7OztBQU1lLFNBQVNBLGtCQUFULEdBQXFGO0VBQ2xHLElBQU1DLE9BQU8sR0FBRyxJQUFBQyxpQkFBQSxFQUFXQyx3QkFBWCxDQUFoQjs7RUFFQSxJQUFJLENBQUNGLE9BQUwsRUFBYztJQUNaLE1BQU0sSUFBSUcsS0FBSixDQUFVLDJFQUFWLENBQU47RUFDRDs7RUFFRCxPQUFPSCxPQUFQO0FBQ0QifQ==